exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#previewBox[data-v-0aa223d2] {\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  background-color: white;\n  border-style: dashed;\n  border-color: #0065B3;\n  z-index: 999;\n}\nbutton[data-v-0aa223d2]{\n  font-size: 5vw;\n}\n.show_reservationpopup[data-v-0aa223d2]{\n  background-color: rgba(41, 189, 140, 0.63);\n  border-radius: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0aa223d2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/boxes/SpPreviewBox.vue
// module id = 471
// module chunks = 0